import React, { useId } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { LntButton, LntDrawer, LntForm, LntFormItem, LntInput } from '@app/components/base'

import { TRANSLATIONS_CONFIG_KEY } from '@app/constants/queryKeys'

import { useNotification } from '@app/hooks'

import {
  getMonitoringValidationSuperAbnormalConfig,
  patchMonitoringValidationSuperAbnormalConfig
} from '@app/api/routes/monitoringValidation'

import styles from './styles.module.scss'

import type { SuperAbnormalPriceDetectionDrawerProps } from './types'
import type { PatchMonitoringValidationSuperAbnormalConfigData } from '@app/api/routes/monitoringValidation/types'

const title = 'Процентное отклонение цен'

export const SuperAbnormalPriceDetectionDrawer: React.FC<SuperAbnormalPriceDetectionDrawerProps> = props => {
  const { onClose } = props

  const formId = useId()

  const queryClient = useQueryClient()
  const notification = useNotification()
  const form = useForm<PatchMonitoringValidationSuperAbnormalConfigData>()

  const { data: configData } = useQuery({
    queryKey: [TRANSLATIONS_CONFIG_KEY.superAbnormalConfig],
    queryFn: async () => await getMonitoringValidationSuperAbnormalConfig()
  })

  const patchConfigDataMutation = useMutation({
    mutationFn: patchMonitoringValidationSuperAbnormalConfig,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [TRANSLATIONS_CONFIG_KEY.superAbnormalConfig] })

      notification.success({
        message: 'Успешно изменено отклонение цен конкурентов.'
      })

      onClose()
    }
  })

  const handleSubmit = (): void => {
    const data = form.getValues()

    patchConfigDataMutation.mutate(data)
  }

  const footerButtons: React.ReactNode = (
    <div className={ styles.superAbnormalPriceDetectionDrawer__footer }>
      <LntButton
        htmlType='submit'
        form={ formId }
        disabled={ !form.formState.isValid }
      >
        Сохранить
      </LntButton>
    </div>
  )

  return (
    <LntDrawer
      { ...props }
      title={ title }
      width={ 424 }
      footer={ footerButtons }
    >
      <LntForm<PatchMonitoringValidationSuperAbnormalConfigData>
        layout='vertical'
        formInstance={ form }
        onSubmit={ handleSubmit }
        id={ formId }
      >
        <LntFormItem
          name='superAbnormalPriceDetectionDeviationPercentage'
          defaultValue={ configData?.superAbnormalPriceDetectionDeviationPercentage }
          label='Отклонение цен конкурентов'
          validationOptions={ { rules: { required: true } } }
          tooltip='Выявление отклонения цен конкурентов от цен Ленты более чем на указанную величину в процентах.'
        >
          <LntInput
            className={ styles.superAbnormalPriceDetectionDrawerFormTop__input }
            placeholder='Значение'
            type='number'
            suffix='%'
          />
        </LntFormItem>
      </LntForm>
    </LntDrawer>
  )
}
